import { render, staticRenderFns } from "./VDatePicker.vue?vue&type=template&id=0907ced4"
import script from "./VDatePicker.vue?vue&type=script&lang=js"
export * from "./VDatePicker.vue?vue&type=script&lang=js"
import style0 from "./VDatePicker.vue?vue&type=style&index=0&id=0907ced4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports